import { useEffect } from'react';
import { useLocation } from'react-router-dom';
import { useAtozasLanguage } from'../../context/AtozasLanguageContext';

/**
 * LanguageInitializer Component
 * - Migrates legacy language selection (if present)
 * - Tracks language selection (for debugging)
 */
const LanguageInitializer = () => {
 const { language, setLanguage } = useAtozasLanguage();
 const location = useLocation();

 useEffect(() => {
 // Migrate legacy stored language (our old context stored an object as JSON)
 // into atozas-traslate language storage.
 try {
 const legacyRaw = localStorage.getItem('uttaapp_selected_language');
 if (!legacyRaw) return;

 const legacy = JSON.parse(legacyRaw);
 const legacyCode = legacy?.code;
 if (!legacyCode || typeof legacyCode !=='string') return;

 // Only auto-apply legacy selection if current language is default (en)
 if (language ==='en') {
 setLanguage(legacyCode);
 console.log('🌐 Migrated legacy language selection to atozas-traslate:', legacyCode);
 }
 } catch (e) {
 // Ignore migration errors
 }
 }, [language, setLanguage]);

 useEffect(() => {
 if (language) {
 console.log(`🌐 Language selected: ${language} on path: ${location.pathname}`);
 }
 }, [language, location.pathname]);

 // This component doesn't render anything
 return null;
};

export default LanguageInitializer;
